/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

const CancellationFeeInformation = ({
    data,
    meetAssistChangesIdentification
}) => {
    const cancellationFee = data?.cancellationFee || 0;
    const meetAssistFee = data?.meetAssistCancellationFee || { arrival: 0, departure: 0 };
    const totalCancellationFee = data?.totalCancellationFee || (cancellationFee + meetAssistFee.arrival + meetAssistFee.departure);
    const refundAmount = data?.refundAmount || 0;
    const chargeAmount = data?.chargeAmount || 0;
    const newBookingTotalPrice = data?.editBooking?.totalPrice || 0;
    const oldBookingTotalPrice = data?.bookingId?.totalPrice || 0;
    const isDeferredPayment = data?.userId?.deferredPaymentEligible;
    const travelDateChanged = data?.changesIdentification?.travelDate?.changed;
    const cancellationDesc = data?.cancellationDesc?.en || "-";
    const meetAssistDesc = data?.meetAssistCancellationDesc || { arrival: { en: "-" }, departure: { en: "-" } };

    const isHigherPrice = (cancellationFee + meetAssistFee.arrival + meetAssistFee.departure + newBookingTotalPrice) > oldBookingTotalPrice;

    const getCancellationFeeDesc = (type, isDateChange) => {
        if (type === "cancel") {
            return "Cancellation Rate";
        } else {
            if (isDateChange) {
                return "Reservation Date Change";
            } else {
                return "Schedule Change Within the Reservation Date";
            }
        }
    }

    function detectDowngradeMeetAssist() {
        if (data?.totalMeetAssistPriceCancellation <= 0) return { departure: false, arrival: false };

        const tier = {
            none: 0,
            meetAssist: 1,
            vipMeetAssist: 2,
        };

        const result = {};

        const oldMap = Object.fromEntries(
            meetAssistChangesIdentification?.old?.map(item => [item.meetAssistType, item]) ?? []
        );

        const newMap = Object.fromEntries(
            meetAssistChangesIdentification?.new?.map(item => [item.meetAssistType, item]) ?? []
        );

        ["arrival", "departure"].forEach(type => {
            const oldItem = oldMap[type];
            const newItem = newMap[type];

            if (!oldItem || !newItem) return;

            const oldTier = tier[oldItem.meetAssistName] ?? 0;
            const newTier = tier[newItem.meetAssistName] ?? 0;

            if (newTier < oldTier) {
                result[type] = true;
            }
        });

        return result;
    }

    const getRefundAmountDetails = () => {
        let priceDifference = 0;

        if(data?.status === "APPROVED") {
            priceDifference = data?.previousBooking?.totalPrice - newBookingTotalPrice;
        }else{
            priceDifference = oldBookingTotalPrice - newBookingTotalPrice;
        }
        return `(= ${priceDifference.toLocaleString()} JPY - ${(cancellationFee + meetAssistFee.arrival + meetAssistFee.departure).toLocaleString()} JPY)`;
    }

    return (
        <>
            <h5 className="tw:!font-hanken-grotesk tw:!mb-4 tw:!text-[15px] tw:!font-[600] tw:!text-[#282828]">
                <span className="tw:relative tw:inline-block">
                    <span className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:h-[40%] tw:rounded-full tw:bg-[#F9EDD3]" />
                    <span className="tw:relative">Booking Modification・Cancellation Fees</span>
                </span>
            </h5>
            <section className="tw:w-full tw:flex tw:flex-col tw:gap-4 tw:mb-6">
                <div className="tw:w-full tw:border tw:border-[#e8e8e8] tw:rounded-[5px] tw:bg-white tw:overflow-hidden">
                    {/* Schedule Change Row */}
                    {data?.totalPriceCancellation > 0 && (
                        <div className="tw:flex tw:w-full tw:p-4 tw:border-b tw:border-[#e8e8e8]">
                            <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                                <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">
                                    {getCancellationFeeDesc(data?.requestType, travelDateChanged)}
                                </p>
                            </div>
                            <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                <div className="tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Cancellation Fee</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{cancellationFee.toLocaleString()} JPY</p>
                                </div>
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Cancellation Rate</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{cancellationDesc}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Meet & Assist Row */}
                    {detectDowngradeMeetAssist().arrival > 0 && (
                        <div className="tw:flex tw:w-full tw:p-4 tw:border-b tw:border-[#e8e8e8]">
                            <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                                <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{`${meetAssistDesc?.arrival?.type === "vipMeetAssist" ? "Arrival VIP Meet & Assist Service Cancellation" : "Arrival Meet & Assist Service Cancellation"}`}</p>
                            </div>
                            <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                <div className="tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Cancellation Fee</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{meetAssistFee?.arrival?.toLocaleString()} JPY</p>
                                </div>
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Cancellation Rate</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{meetAssistDesc?.arrival?.en}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {detectDowngradeMeetAssist().departure > 0 && (
                        <div className="tw:flex tw:w-full tw:p-4 tw:border-b tw:border-[#e8e8e8]">
                            <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                                <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">{`${meetAssistDesc?.departure?.type === "vipMeetAssist" ? "Departure VIP Meet & Assist Service Cancellation" : "Departure Meet & Assist Service Cancellation"}`}</p>
                            </div>
                            <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                                <div className="tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Cancellation Fee</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{meetAssistFee?.departure?.toLocaleString()} JPY</p>
                                </div>
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Cancellation Rate</p>
                                    <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{meetAssistDesc?.departure?.en}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Total Row */}
                    <div className="tw:flex tw:w-full tw:p-4 tw:bg-[#f9f9f9]">
                        <div className="tw:w-1/3 tw:lg:w-1/4 tw:pr-4 tw:flex tw:items-center">
                            <p className="tw:!w-full tw:!text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Total</p>
                        </div>
                        <div className="tw:!w-full tw:border-l tw:border-[#e8e8e8] tw:flex tw:flex-col tw:lg:flex-row">
                            <div className="tw:w-full tw:lg:w-1/3 tw:px-5 tw:md:px-7 tw:mb-3 tw:lg:mb-0">
                                <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Total Cancellation Fee</p>
                                <p className="tw:text-[#282828] tw:!font-[400] tw:!text-[15px] tw:!mb-0">{totalCancellationFee.toLocaleString()} JPY</p>
                            </div>
                            {isDeferredPayment ? (
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">Updated Booking Fee</p>
                                    <p className="tw:!text-[#20639B] tw:!font-[700] tw:!text-[15px] tw:!mb-0">{(cancellationFee + meetAssistFee.arrival + meetAssistFee.departure + newBookingTotalPrice).toLocaleString()} JPY</p>
                                </div>
                            ) : isHigherPrice ? (
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">
                                        {refundAmount === 0 ? "Updated Booking Fee" : "Refund Amount (Price Difference - Total Cancellation Fee)"}
                                    </p>
                                    <div className="tw:!flex tw:!items-baseline tw:!gap-1">
                                        <span className="tw:!text-[#20639B] tw:!font-[700] tw:!text-[15px] tw:!mb-0">{refundAmount === 0
                                            ? (cancellationFee + meetAssistFee.arrival + meetAssistFee.departure + newBookingTotalPrice).toLocaleString()
                                            : refundAmount.toLocaleString()
                                        } JPY</span>
                                        <span className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[13px] tw:!mb-0">{getRefundAmountDetails()}</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="tw:w-full tw:lg:flex-1 tw:pl-5 tw:md:pl-7">
                                    <p className="tw:!text-[#8D8D8D] tw:!font-[400] tw:!text-[13px] tw:!mb-0 tw:!flex tw:!justify-start tw:!text-left">
                                        {refundAmount === 0 ? "Refund" : "Refund Amount (Price Difference - Total Cancellation Fee)"}
                                    </p>
                                    {refundAmount === 0 ? (
                                        <p className="tw:!text-[#A7A7A7] tw:!font-[400] tw:!text-[15px] tw:!mb-0">N/A</p>
                                    ) : (
                                        <div className="tw:!flex tw:!items-baseline tw:!gap-1">
                                            <span className="tw:!text-[#20639B] tw:!font-[700] tw:!text-[15px] tw:!mb-0">{refundAmount.toLocaleString()} JPY</span>
                                            <span className="tw:!text-[#7C7B7B] tw:!font-[400] tw:!text-[13px] tw:!mb-0">{getRefundAmountDetails()}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CancellationFeeInformation;
